import type { GamificationStats } from '@testflow/shared';
import { useTranslation } from 'react-i18next';

// GAM-1: dezenter Streak-Indikator im Header der Tester-Minimal-Shell (Design-Spec §3.3 Top-Bar).
// Gelb (`--brand-accent-2`) laut Design-Spec §Farbtabelle ("Avatare, Warn-Badges, Streak").
// Abschaltbar (Projekt-Toggle ODER User-Opt-out) — der Server fasst beides bereits in
// `stats.enabled` zusammen, hier also nur noch `null` rendern statt eigene Toggle-Logik.
export function StreakChip({ stats }: { stats: GamificationStats }) {
  const { t } = useTranslation();
  if (!stats.enabled) return null;

  return (
    <span className="inline-flex items-center gap-1 rounded-chip border border-brand-accent-2/40 bg-brand-accent-2/10 px-2 py-1 text-xs font-semibold text-brand-accent-2">
      {t('gam.streakDays', { count: stats.streak_days })}
    </span>
  );
}
